import {Column, Entity, JoinColumn, OneToMany, OneToOne} from "typeorm";
import type {Relation} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Terrace} from "@/modules/stadium/entity/Terrace";
import {Min} from "class-validator";
import {Team} from "@/modules/team/entity";

@Entity()
export class Stadium extends BaseEntity {
  @OneToMany(() => Terrace, r => r.stadium)
  terraces: Relation<Terrace[]>;

  @OneToOne(() => Team)
  @JoinColumn()
  team: Relation<Team>;

  @Column({type: 'integer', unsigned: true})
  @Min(1)
  foundationLevel = 1;

  @Column({type: 'date', nullable: true})
  foundationFinishedAt?: Date | null;

  get seats() {
    return collect(this.terraces)
      .filter((terrace: Terrace) => terrace.available && !terrace.seatsFinishedAt)
      .sum('seats');
  }

  get seatsWhenFinished() {
    return collect(this.terraces).sum((terrace: Terrace) => terrace.seatsTarget ?? terrace.seats);
  }

  get limit() {
    return collect(this.terraces).sum('seatsLimit');
  }
}
